import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { List } from "../Utils/List";


export enum DiffType { Diff, Skip, Match };


export class DiffSpan implements ObjectSerializer {

	public type: DiffType;
	public start: number;
	public length: number;

	constructor(type: DiffType = undefined, start: number = 0, length: number = 0) {
		this.type = type;
		this.start = start;
		this.length = length;
	}

	public static readonly ObjSerName = "DiffSpan.ObjSerName";

	public Write(obj: any, context: any): void {

		let objSerName: string = "diff_span";
		if (context[DiffSpan.ObjSerName]) {
			objSerName = context[DiffSpan.ObjSerName];
		}

		obj[objSerName] = {};
		obj = obj[objSerName];

		obj.type = DiffType[this.type];
		obj.start = ValueEncoder.EncodeInteger(this.start);
		obj.length = ValueEncoder.EncodeInteger(this.length);
	}


	public Read(obj: any, context: any): void {

		let objSerName: string = "diff_span";
		if (context[DiffSpan.ObjSerName]) {
			objSerName = context[DiffSpan.ObjSerName];
		}

		if (!obj[objSerName])
			throw new Error();
		obj = obj[objSerName];

		if (obj.type !== undefined)
			this.type = DiffType[<string>obj.type];

		if (obj.start !== undefined)
			this.start = ValueEncoder.DecodeInteger(obj.start);

		if (obj.length !== undefined)
			this.length = ValueEncoder.DecodeInteger(obj.length);
	}
}


export class DiffSpans implements ObjectSerializer {

	public lines: List<string>;
	public spans: List<DiffSpan>;
	public curSpan: DiffSpan;
	public lineCount: number;
	public diffCount: number;

	constructor() {
		this.lines = new List<string>();
		this.spans = new List<DiffSpan>();
		this.curSpan = null;
		this.lineCount = 0;
		this.diffCount = 0;
	}

	public getDiffLines(diff: DiffSpan): string[] {

		let lines: string[] = new Array(diff.length);

		if (diff.type == DiffType.Skip) {
			for (let i = 0; i < diff.length; i++) {
				lines[i] = null;
			}
		}
		else {
			for (let i = 0; i < diff.length; i++)
				lines[i] = this.lines.Get(diff.start + i);
		}

		return lines;
	}


	public static readonly ObjSerName = "DiffSpans.ObjSerName";

	public Write(obj: any, context: any): void {

		let objSerName: string = "diff_spans";
		if (context[DiffSpans.ObjSerName]) {
			objSerName = context[DiffSpans.ObjSerName];
		}

		obj[objSerName] = {};
		obj = obj[objSerName];

		obj.lines = [];
		ObjSerUtils.WriteStringCollection(obj.lines, this.lines, "value", context);

		obj.spans = [];
		ObjSerUtils.WriteObjSerCollection(obj.spans, this.spans, context);

		if (this.curSpan) {
			context[DiffSpan.ObjSerName] = "current_span";
			this.curSpan.Write(obj, context);
			delete context[DiffSpan.ObjSerName];
		}

		obj.line_count = ValueEncoder.EncodeInteger(this.lineCount);
		obj.diff_count = ValueEncoder.EncodeInteger(this.diffCount);
	}

	public Read(obj: any, context: any): void {

		let objSerName: string = "diff_spans";
		if (context[DiffSpans.ObjSerName]) {
			objSerName = context[DiffSpans.ObjSerName];
		}

		if (!obj[objSerName])
			throw new Error();
		obj = obj[objSerName];

		if (obj.lines !== undefined) {
			ObjSerUtils.ReadStringCollection(obj.lines, this.lines, "value", context);
		}

		if (obj.spans !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.spans, this.spans,
				(value: any) => new DiffSpan(), context);
		}

		if (obj.current_span !== undefined) {
			this.curSpan = new DiffSpan();
			context[DiffSpan.ObjSerName] = "current_span";
			this.curSpan.Read(obj, context);
			delete context[DiffSpan.ObjSerName];
		}

		if (obj.line_count !== undefined)
			this.lineCount = ValueEncoder.DecodeInteger(obj.line_count);

		if (obj.diff_count !== undefined)
			this.diffCount = ValueEncoder.DecodeInteger(obj.diff_count);
	}
}


export class DiffResult implements ObjectSerializer {

	public leftSpans: DiffSpans;
	public rightSpans: DiffSpans;

	constructor() {
		this.leftSpans = new DiffSpans();
		this.rightSpans = new DiffSpans();
	}

	public Write(obj: any, context: any): void {

		obj.diff_result = {};
		obj = obj.diff_result;

		context[DiffSpans.ObjSerName] = "left_spans";
		this.leftSpans.Write(obj, context);
		delete context[DiffSpans.ObjSerName];

		context[DiffSpans.ObjSerName] = "right_spans";
		this.rightSpans.Write(obj, context);
		delete context[DiffSpans.ObjSerName];
	}

	public Read(obj: any, context: any): void {

		if (!obj.diff_result)
			throw new Error();
		obj = obj.diff_result;

		if (obj.left_spans !== undefined) {
			this.leftSpans = new DiffSpans();
			context[DiffSpans.ObjSerName] = "left_spans";
			this.leftSpans.Read(obj, context);
			delete context[DiffSpans.ObjSerName];
		}

		if (obj.right_spans !== undefined) {
			this.rightSpans = new DiffSpans();
			context[DiffSpans.ObjSerName] = "right_spans";
			this.rightSpans.Read(obj, context);
			delete context[DiffSpans.ObjSerName];
		}
	}
}
